import { defineStore } from 'pinia';
import httpClient from "@/lib/httpClient";

export const useMainStore = defineStore('main', {
  state: () => ({
    currentUserName: "",
    currentMachine: {},
    statesData: [],
    isLoading: false,
    error: null,
  }),
  
  actions: {
    async forceUpdateCurrentMachine(machineId) {
      console.log("force update machine data",machineId)
      const response = await httpClient.get(`/machines/${machineId}`);
      if (response.data) {
        this.currentMachine = response.data; // Update with new data
      } else {
        throw new Error('Invalid machine data');
      }
    },
    async updateCurrentMachine(machineId) {
       
  
      // Check if the current machine is the one we want to update
      if (this.currentMachine.id === machineId) return;

      this.isLoading = true; // Set loading state
      this.error = null; // Reset any previous error
      this.currentMachine = {}; // Clear current machine

      try {
        const response = await httpClient.get(`/machines/${machineId}`);
        
        if (response.data) {
          this.currentMachine = response.data; // Update with new data
        } else {
          throw new Error('Invalid machine data');
        }
      } catch (err) {
        this.error = err; // Capture any errors
        console.error("Error fetching machine data:", err);
      } finally {
        this.isLoading = false; // Reset loading state
      }
    },
    async fetchStatesData() {
      console.log("fetch state data")
      // Fetch states data only if it's not already fetched
      if (this.statesData.length > 0) return;

      this.isLoading = true; // Set loading state
      this.error = null; // Reset any previous error

      try {
        const response = await httpClient.get(`/states`);
        if (response.data) {
          this.statesData = response.data; // Update states data
        } else {
          throw new Error('Invalid states data');
        }
      } catch (err) {
        this.error = err; // Capture any errors
        console.error("Error fetching states data:", err);
      } finally {
        this.isLoading = false; // Reset loading state
      }
    },
   
  },
});
